import React, { Component } from 'react';
import { Spinner } from 'reactstrap';
import ModalAvailability from './ModalAvailability';
import ModalInactive from './ModalInactive';
import ModalInvoiceList from './ModalInvoiceList';
import ModalDocuments from './ModalDocuments';
import TrialSchedule from './TrialSchedule';
import BookingNotes from './BookingNotes';
import ModalInspiration from './ModalInspiration';
import Gravatar from 'react-gravatar';
import { inject } from 'mobx-react';
import { connectionGet, connectionPost } from '../../utils/connection';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from 'react-input-mask';
import moment from 'moment';
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
} from 'react-places-autocomplete';

@inject('userStore')
class BookingQuickview2 extends Component {
    constructor(props){
        super(props);
        this.state = {
          editTime:false,
          startTime:new Date(),
          edit:false,
          quickviewBooking:null,
          address:''
        }
    }

    componentDidMount(){
      this.getBooking(this.props.hash_id);
    }

    componentWillReceiveProps(nextProps){
      this.getBooking(nextProps.hash_id)
    }

    welcomeEmail = () => {
      if (this.state.quickviewBooking){
        connectionPost('post/welcome-email', {hash_id:this.state.quickviewBooking.hash_id}, {username: this.props.userStore.token}
        ).then((res) => {
          if (res.data.errors === 0){
            this.setState({
              quickviewBooking:res.data.booking
            },()=>alert(res.data.message))
          } else {
            alert(res.data.message);
          }
        }).catch((error) => {
          console.log(error);
          return error;
        });
      }
    }

    getPlace = placeId => {
      var service = new window.google.maps.places.PlacesService(document.createElement('div'));
      return new Promise((resolve, reject) => {
        service.getDetails({'placeId':placeId}, (results, status)=>{
          if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
    };

    handleAddressChange = address => {
      let updated_obj = Object.assign({}, this.state.quickviewBooking);
      updated_obj.location_name = address;
      this.setState({quickviewBooking:updated_obj});
    };

    handleSelect = address => {
      geocodeByAddress(address)
        .then(results => {
          this.getPlace(results[0].place_id).then(results => {
            this.handleInputChangeDirect("location_name", results.name);
            for (var i = 0; i < results.address_components.length; i++) {
              var addressType = results.address_components[i].types[0];
              if (addressType == 'street_number'){
                this.handleInputChangeDirect("address", results.address_components[i].long_name);
              }
              if (addressType == 'route'){
                this.handleInputChangeDirect("address", this.state.quickviewBooking.address + " " + results.address_components[i].short_name);
              }
              if (addressType == 'locality'){
                this.handleInputChangeDirect("city", results.address_components[i].long_name);
              }
              if (addressType == 'administrative_area_level_1'){
                this.handleInputChangeDirect("state", results.address_components[i].short_name);
              }
              if (addressType == 'postal_code'){
                this.handleInputChangeDirect("postal_code", results.address_components[i].short_name);
              }
            }
          });
        });
    };

    getBooking = (hash_id) => {
      connectionGet('v2/bookings/' + hash_id, {}, {username: this.props.userStore.token})
      .then((res) => {
        this.setState({
          quickviewBooking:res.data.booking,
          startTime:res.data.booking.utc_date,
          editTime:false
        });
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    handleInputChange = (e) => {
      let updated_obj = Object.assign({}, this.state.quickviewBooking);
      updated_obj[e.target.name] = e.target.value;
      this.setState({quickviewBooking:updated_obj});
    }

    handleInputChangeDirect = (name, value) => {
      let updated_obj = Object.assign({}, this.state.quickviewBooking);
      updated_obj[name] = value;
      this.setState({quickviewBooking:updated_obj});
    }

    handleChange = (date) => {
      this.setState({
        startTime: date
      });
    }

  render() {
    if (!this.state.quickviewBooking) return <div className="p-20"><Spinner color="primary"/>  Loading Booking...</div>;
    const {edit, quickviewBooking} = this.state;
    const {modalHandler, servicesHandler, closeHandler, scheduleHandler, startTimeHandler, resetHandler, resendHandler, editHandler} = this.props;
    if (!quickviewBooking) return <React.Fragment>No Booking</React.Fragment>;
    return (
        <PerfectScrollbar>
        <div className="quickview-body">
          <div className="card card-inverse mb-0">
            <div className="px-20 pt-20">
              <a className="pull-right text-white fs-20 lh-1 cursor-pointer" onClick={closeHandler}><i className="fa fa-close"></i></a>
            </div>
            <div className="card-body text-center pb-10 pt-0">
              <h4 className="mt-2 mb-0 text-white"><Gravatar email={quickviewBooking.email} size={96} rating="pg" default="identicon" className="avatar avatar-bordered" /> {quickviewBooking.first_name} {quickviewBooking.last_name}</h4>
              <span><i className="fa fa-envelope w-20px"></i> <a className="hover-primary text-white" href={"mailto:" + quickviewBooking.email}>{quickviewBooking.email}</a></span><br/>
              <span><i className="fa fa-phone w-20px"></i> {quickviewBooking.phone}</span>
            </div>
          </div>
          <div className="quickview-block pb-0">
            {edit ?
              <form className="card form-type-combine">
                <div className="form-groups-attached">
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Booking Name</label>
                            <input type="text" className="form-control" name="event_name" value={quickviewBooking.event_name} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>First Name</label>
                            <input type="text" className="form-control" name="first_name" value={quickviewBooking.first_name} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group col-6">
                            <label>Last Name</label>
                            <input type="text" className="form-control" name="last_name" value={quickviewBooking.last_name} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-8">
                            <label>Email</label>
                            <input type="email" className="form-control" name="email" value={quickviewBooking.email} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group col-4">
                            <label>Phone</label>
                            <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone" value={quickviewBooking.phone} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Location Name</label>
                        <PlacesAutocomplete value={quickviewBooking.location_name} onChange={this.handleAddressChange} onSelect={this.handleSelect}>
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <React.Fragment>
                            <input
                                {...getInputProps({
                                  className: 'form-control',
                                })}
                            />
                            <div className={suggestions.length > 0 ? "autocomplete-dropdown-container" : null}>
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion,idx) => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                return (
                                  <div key={idx} style={{ borderWidth: 0.5, borderColor: '#d6d7da'}}
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </React.Fragment>
                        )}
                        </PlacesAutocomplete>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Address</label>
                            <input className="form-control" type="text" name="address" value={quickviewBooking.address} onChange={this.handleInputChange}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>City</label>
                            <input className="form-control" type="text" name="city" value={quickviewBooking.city} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group col-2">
                            <label>State</label>
                            <input className="form-control" type="text" name="state" value={quickviewBooking.state} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group col-4">
                            <label>Postal Code</label>
                            <input className="form-control" type="text" name="postal_code" value={quickviewBooking.postal_code} onChange={this.handleInputChange}/>
                        </div>
                    </div>
                    <div className="form-group">
                      <div className="btn-group">
                        <button className="btn btn-secondary" type="button" onClick={()=>this.setState({edit:false})}>Cancel</button>
                        <button className="btn btn-primary" type="button" onClick={()=>editHandler(quickviewBooking)}>Save</button>
                      </div>
                    </div>
                </div>
              </form>
              :
              <React.Fragment>
                <dl className="row">
                {!this.state.editTime ?
                  <React.Fragment>
                    <dt className="col-sm-3">Ready Time</dt>
                    <dd className="col-sm-9"><React.Fragment>{quickviewBooking.date} @ {quickviewBooking.ready_time} <a onClick={()=>{this.setState({editTime:!this.state.editTime})}}><i className="fa fa-pencil text-info cursor-pointer"></i></a></React.Fragment></dd>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <dd className="col-sm-12">
                      <DatePicker
                        selected={moment(this.state.startTime, moment.ISO_8601).toDate()}
                        onChange={this.handleChange}
                        showTimeSelect
                        timeIntervals={5}
                        inline
                        dateFormat="h:mm aa"
                        timeCaption="Time"
                      />
                      <a className="ml-10" onClick={()=>{startTimeHandler(this.state.startTime, quickviewBooking)}}><i className="fa fa-check text-success cursor-pointer"></i></a>
                      <a className="ml-10" onClick={()=>{this.setState({editTime:!this.state.editTime})}}><i className="fa fa-close text-danger cursor-pointer"></i></a>
                  </dd>
                  </React.Fragment>
                  }
                  <dt className="col-sm-3">Location</dt>
                  <dd className="col-sm-9" style={{lineHeight:18+'px'}}>
                  <address>
                    <strong>{quickviewBooking.location_name} <a target="_blank" href={'http://maps.google.com/?q='+quickviewBooking.address + quickviewBooking.address2}><i className="fa fa-external-link text-info"></i></a></strong><br/>
                    {quickviewBooking.address}<br/>
                    {quickviewBooking.address2}
                  </address>
                  </dd>
                  {quickviewBooking.location_instructions && quickviewBooking.location_instructions !== '' ?
                  <React.Fragment>
                  <dt className="col-sm-3">Instructions</dt>
                  <dd className="col-sm-9" style={{lineHeight:18+'px'}}>{quickviewBooking.location_instructions}</dd>
                  </React.Fragment>
                  : null}
                  <dt className="col-sm-3">Modified</dt>
                  <dd className="col-sm-9">{quickviewBooking.last_modified}<br/><strong>{quickviewBooking.age_of}</strong></dd>
                </dl>
                <TrialSchedule booking={quickviewBooking} hideHint={true}/>
              </React.Fragment>
            }
          </div>
        </div>
        <footer className="p-12 text-center">
          <div className="btn-group btn-block btn-group-vertical">
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => servicesHandler(quickviewBooking)}><i className="fa-fw fa fa-scissors"></i> Services</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalAvailability, "Assign Artists for " + quickviewBooking.date + " @ " + quickviewBooking.ready_time)}><i className="fa-fw fa fa-users"></i> Assign Artists</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, BookingNotes, "Internal Notes & Follow Up")}><i className="fa-fw fa fa-sticky-note-o"></i> Notes</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalInspiration, "Inspiration Ideas")}><i className="fa-fw fa fa-lightbulb-o"></i> Inspiration Ideas</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => scheduleHandler(quickviewBooking)}><i className="fa-fw fa fa-clock-o"></i> Set Schedule</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalDocuments, "Event Documents")}><i className="fa-fw fa fa-file-pdf-o"></i> Event Documents</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalInvoiceList, "Payments & Invoices for " + quickviewBooking.full_name + " Event" )}><i className="fa-fw fa fa-money"></i> Payments & Invoices</button>
              <div className="btn-group">
                <button className="btn btn-lg btn-outline btn-block btn-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Additional Actions</button>
                <div className="dropdown-menu" x-placement="bottom-start" style={{position:"absolute", willChange: "top, left", top: 36+"px", left: 0+"px"}}>
                  <a className="dropdown-item" href={"mailto:" + quickviewBooking.email}><i className="fa fa-fw fa-envelope"></i> Message</a>
                  <a className="dropdown-item" href="#" onClick={this.welcomeEmail}><i className="fa-fw fa fa-info-circle"></i> Send Welcome Message {quickviewBooking.welcome_sent && quickviewBooking.welcome_sent === 1 ? <small className="badge badge-info">Sent</small> : null}</a>
                  <a className="dropdown-item" href="#" onClick={()=>resendHandler(quickviewBooking)}><i className="fa-fw fa fa-asterisk"></i> Send Account Information</a>
                  <a className="dropdown-item" href="#" onClick={()=>resetHandler(quickviewBooking)}><i className="fa-fw fa fa-refresh"></i> Reset Password</a>
                  <a className="dropdown-item" href="#" onClick={()=>this.setState({edit:true})}><i className="fa-fw fa fa-pencil"></i> Update Event</a>
                </div>
              </div>
              <button className="btn btn-lg btn-outline btn-block btn-danger" onClick={(event) => modalHandler(quickviewBooking, ModalInactive, "Inactivate Booking")}><i className="fa fa-fw fa-trash"></i> Mark Inactive</button>
              <button className="btn btn-lg btn-outline btn-block btn-info" onClick={closeHandler}><i className="fa fa-fw fa-close"></i> Close</button>
          </div>
        </footer>
        </PerfectScrollbar>
    )
  }
}

export default BookingQuickview2;



// WEBPACK FOOTER //
// ./src/components/business/BookingQuickview.2.js